import React, { useEffect, useState } from "react";
import { Masonry, Empty, Typography, Spin } from "antd";
import { UserOutlined } from "@ant-design/icons";

const { Title, Text, Paragraph } = Typography;

const FIELD_LABELS = [
  ["discipline", "Discipline"],
  ["occupation", "Occupation"],
  ["experience", "Experience"],
];

function TeamCard({ person }) {
  return (
    <div style={{
      background: "rgba(255,255,255,0.03)",
      border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: 12,
      overflow: "hidden",
    }}>
      <div style={{ aspectRatio: "1 / 1", background: "rgba(255,255,255,0.04)" }}>
        {person.hasImage ? (
          <img
            src={`/api/team/${encodeURIComponent(person.name)}/image?v=${person.imageVersion}`}
            alt={person.name}
            style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
          />
        ) : (
          <div style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <UserOutlined style={{ fontSize: 44, color: "rgba(255,255,255,0.15)" }} />
          </div>
        )}
      </div>
      <div style={{ padding: "16px 18px" }}>
        <Title level={5} style={{ margin: 0, letterSpacing: "-0.2px" }}>{person.name}</Title>
        {person.position && (
          <Text style={{ fontSize: 12.5, color: "#4f9cf9", display: "block", marginTop: 2 }}>
            {person.position}
          </Text>
        )}
        {FIELD_LABELS.some(([key]) => person[key]) && (
          <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 5 }}>
            {FIELD_LABELS.map(([key, label]) => person[key] && (
              <div key={key} style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{
                  fontSize: 9.5, textTransform: "uppercase",
                  letterSpacing: "0.08em", color: "rgba(255,255,255,0.35)", minWidth: 68, flexShrink: 0,
                }}>
                  {label}
                </span>
                <span style={{ fontSize: 12.5, color: "rgba(255,255,255,0.8)" }}>{person[key]}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default function Team() {
  const [team, setTeam]       = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/team")
      .then((r) => r.json())
      .then((data) => setTeam(data.team || []))
      .catch(() => setTeam([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ overflowY: "auto", flex: 1, padding: "48px 48px 32px" }}>

      <div style={{ textAlign: "center", marginBottom: 40 }}>
        <Title style={{ margin: 0, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
          Our <em style={{ fontStyle: "normal", color: "#4f9cf9" }}>Team</em>
        </Title>
        <Paragraph style={{ color: "rgba(255,255,255,0.5)", fontSize: 14, maxWidth: 480, margin: "8px auto 0" }}>
          The people behind PROYAPI's Digital Infrastructure platform.
        </Paragraph>
      </div>

      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: 48 }}>
          <Spin size="large" />
        </div>
      ) : team.length === 0 ? (
        <Empty description="No team members listed yet" image={Empty.PRESENTED_IMAGE_SIMPLE} />
      ) : (
        <div style={{ maxWidth: 1200, margin: "0 auto" }}>
          <Masonry
            items={team.map((p) => ({ key: p.name, data: p }))}
            columns={{ xs: 1, sm: 2, md: 3, lg: 4 }}
            gutter={16}
            itemRender={({ data }) => <TeamCard person={data} />}
          />
        </div>
      )}
    </div>
  );
}
